<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <i class="fa fa-bug"></i> {{ $t('faultDetectionKeyword') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab :title="$t('activated')"></b-tab>
          <b-tab :title="$t('deactivated')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
              :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12">
        <div class="c-sorting" v-if="['owner','admin', 'tech', 'account', 'operationsManager', 'am'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus" />&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
            <!-- col -->
          </div>
          <!-- row -->
        </div>
        <!-- c-sorting -->
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <!-- c-paging -->
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-6">{{ $t('keyword') }}</div>
            <div class="col-lg-4">{{ $t("createTime") }}</div>
            <div class="col-lg-2" ></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-6">
              <div>
                <b>{{ $t('keyword') }}: </b>
                <span>{{ item.name }}</span>
              </div>
              <div v-if="item.desc">
                <b>{{ $t('desc') }}: </b>
                <span>{{ item.desc }}</span>
              </div>
              <div>
                <label v-if="item.active" class="badge badge-success">{{ $t('activated') }}</label>
                <label v-if="!item.active" class="badge badge-danger">{{ $t('deactivated') }}</label>
              </div>
              <div>
                <label v-if="item.autoLocked" class="badge badge-warning">{{ $t('autoLocked') }}</label>
              </div>
            </div>
            <div class="col-lg-4">
              <p>
                <span >{{
                    item.createTime | moment("DD/MM/YY HH:mm:ss")
                }}</span>
              </p>
              </div>
            <div class="col-lg-2 text-right">
              <div class="c-smart-table__content"  v-if="['owner','admin', 'tech', 'account', 'operationsManager', 'am'].includes($store.state.user.role)">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button @click="update(item._id)" type="button" class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit" />&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash" />&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
          v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize" @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <form-input :label="$t('keyword')" :model="formModel" attribute="name" :errors="formErrors" />
      <form-textarea :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors" />
      <form-checkbox :chk-label="$t('autoLocked')" :model="formModel" attribute="autoLocked" :errors="formErrors" />
      <form-checkbox :chk-label="$t('activated')" :model="formModel" attribute="active" :errors="formErrors" />
    </b-modal>
  </main>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";

export default {
  mixins: [List, CRUD],
  data: function () {
    return {
      saveLoading: false,
      service: '/fault-detection-keyword',
      defaultFormModel: {
        autoLocked: false,
        active: true,
      },
      defaultFilterFormModel: {
        keyword: null,
      },
    }
  },
  computed: {
  },
  i18n: {
    messages: {
      en: {
        nameUpdate:'Updater',
        notUpdated: 'Not updated',
        name:'name',
        keyword: 'Keyword',
        desc: 'Description',
        faultDetectionKeyword: 'Fault detection keyword',
        department: 'Department',
        group: 'Group',
        autoLocked: "Tự động khoá số khi phát hiện"
      },
      vi: {
        nameUpdate:'Nhân viên cập nhật',
        notUpdated: 'Chưa cập nhật',
        name:'Tên ',
        keyword: 'Từ khóa',
        desc: 'Mô tả',
        faultDetectionKeyword: 'Phát hiện lỗi theo từ khóa',
        viewer: 'Viewer',
        autoLocked: "Tự động khoá số khi phát hiện"
      }
    }
  },
  methods: {
  },
  mounted() {
    this.getBusinessCategoryList();
  }
};
</script>
